import { useRef, useState } from 'react';
import EditIcon from '@mui/icons-material/Edit';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';

export default function ProfileAvatar({ candidate, url, onSelectFile, loading }) {
  const inputRef = useRef(null);
  const [previewSrc, setPreviewSrc] = useState('');

  const handlePick = () => inputRef.current?.click();

  const handleFileChange = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    // (Optional) simple validation
    if (!file.type.startsWith('image/')) {
      alert('Please select an image file.');
      return;
    }
    if (file.size > 2 * 1024 * 1024) {
      alert('Max 2MB image allowed.');
      return;
    }

    // local preview
    const localUrl = URL.createObjectURL(file);
    setPreviewSrc(localUrl);

    // pass file to parent (upload API call etc.)
    onSelectFile?.(file);

    // allow re-selecting same file again
    e.target.value = '';
  };

  const avatarSrc = previewSrc || `${url}${candidate.profileImage}`;

  return (
    <Box sx={{ position: 'relative', display: 'inline-flex' }}>
      <Avatar
        alt={`${candidate.firstName?.toUpperCase()} ${candidate.lastName || ''}`}
        src={avatarSrc}
        sx={{ width: 80, height: 80, borderRadius: '50%' }}
      />

      {/* hidden input */}
      <input ref={inputRef} type="file" accept="image/*" hidden onChange={handleFileChange} />

      {/* edit button overlay */}
      <Tooltip title="Change photo">
        <IconButton
          onClick={handlePick}
          size="small"
          sx={{
            position: 'absolute',
            right: -6,
            bottom: -6,
            bgcolor: 'background.paper',
            border: '1px solid',
            borderColor: 'divider',
            boxShadow: 2,
            '&:hover': { bgcolor: 'background.paper' },
          }}
          disabled={loading}
        >
          {loading ? <CircularProgress size={16} /> : <EditIcon fontSize="small" />}
        </IconButton>
      </Tooltip>
    </Box>
  );
}
